import { createRouter, createWebHistory, useRoute } from 'vue-router';

import { API_URL } from '@/common/constantes.ts';
import Profile from '@/profile/profile.view.vue';
import Home from '@/views/home.view.vue';
import { eventos } from '@/router/eventos.ts';
import { empresa } from '@/router/empresa.ts';

const routes = [
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '/',
    redirect: '/eventos',
  },
  {
    path: '/login',
    name: 'Login',
    component: Home,
    beforeEnter() {
      location.href = `${API_URL}/auth/login?redirect=${encodeURI(useRoute().fullPath)}`;
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Home,
    beforeEnter() {
      location.href = `${API_URL}/auth/logout`;
    },
  },
  eventos,
  empresa,
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
